"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactHelmet = require("react-helmet");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable jsx-a11y/anchor-is-valid */
var LocationDetail = function LocationDetail(props) {
  var location = props.locations.find(function (loc) {
    return loc.UniqueId.toString() === props.match.params.id.toString();
  });

  var phoneClickHandler = function phoneClickHandler() {
    window.location.href = "tel:".concat(location.Phone);
    window.DGS.Event.getInstance().trigger('trackLocationsPhoneNumber', location.Name, location.PostalCode);
  };

  var websiteClickHandler = function websiteClickHandler() {
    window.open(location.Homepage);
    window.DGS.Event.getInstance().trigger('trackLocationsWebsiteLink', location.Name, location.PostalCode);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "location-detail"
  }, location && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("title", null, location.Name)), /*#__PURE__*/_react["default"].createElement("button", {
    className: "close-button",
    onClick: function onClick(e) {
      props.onCloseLocation(e);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, location.Name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "info"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-left-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "address"
  }, location.Address), /*#__PURE__*/_react["default"].createElement("div", {
    className: "address"
  }, location.PostalCode, " ", location.City), /*#__PURE__*/_react["default"].createElement("div", {
    className: "distance"
  }, /*#__PURE__*/_react["default"].createElement("i", null, "".concat(props.distance, " ").concat(props.settings.Unit, " ").concat(props.settings.dictionary.fromYourLocation)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-right-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "phone"
  }, "".concat(props.settings.dictionary.phone, " :"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    onClick: phoneClickHandler,
    title: location.Phone
  }, location.Phone)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "website"
  }, "".concat(props.settings.dictionary.website, ": "), /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    onClick: websiteClickHandler,
    title: location.Homepage
  }, location.Homepage))))));
};

LocationDetail.propTypes = {
  onCloseLocation: _propTypes2["default"].func,
  settings: _propTypes2["default"].settings.isRequired,
  locations: _propTypes2["default"].locations.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  match: _propTypes["default"].object.isRequired,
  distance: _propTypes["default"].string.isRequired
};
LocationDetail.defaultProps = {
  onCloseLocation: _propTypes2["default"].defaultOnCloseLocation
};

var _default = (0, _reactRouterDom.withRouter)(LocationDetail);

exports["default"] = _default;